import React from 'react';

const IconShow = ({className}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22px" viewBox="0 0 22 13" className={className}>
        <path d="M21.9 6.2C21.7 6 17.6 0 11 0 5.4 0 .3 5.9.1 6.2c-.1.2-.1.4 0 .6C.3 7.1 5.4 13 11 13s10.7-5.9 10.9-6.2c.1-.2.1-.4 0-.6zM11 12c-4.5 0-8.8-4.4-9.9-5.5C2.2 5.3 6.5 1 11 1c5.3 0 9 4.3 9.9 5.5-1 1.1-5.3 5.5-9.9 5.5z" />
        <path d="M11 2.8c-2 0-3.7 1.7-3.7 3.7S9 10.2 11 10.2s3.7-1.7 3.7-3.7S13 2.8 11 2.8zm0 6.5C9.5 9.3 8.2 8 8.2 6.5S9.5 3.7 11 3.7s2.8 1.2 2.8 2.8-1.3 2.8-2.8 2.8z" />
    </svg>
);

export default IconShow;